import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiginForm } from '../modules/form';
import SEO from '../components/SEO';
import { useAnalytics } from '../hooks/useAnalytics';
import './DownloadPage.css';

const DownloadPage: React.FC = () => {
  const { t } = useTranslation();
  const { trackFormInteraction, trackConversion } = useAnalytics();

  // Track when user lands on download page
  React.useEffect(() => {
    trackConversion('Page View', 'Download Page');
  }, [trackConversion]);

  return (
    <>
      <SEO 
        title={t('download_title')}
        description={t('download_subtitle')}
        keywords="cloud consumption guide, cloud cost optimization, cloud management, FinOps guide, cloud blind spots"
      />
      <div className="download-page">
      <div className="download-header">
        <h1>{t('download_title')}</h1>
        <p>{t('download_subtitle')}</p>
      </div>
      
      <div className="download-content">
        <div className="download-description">
          <h2>{t('download_benefits_title')}</h2>
          <ul>
            <li>{t('download_benefit_1')}</li>
            <li>{t('download_benefit_2')}</li>
            <li>{t('download_benefit_3')}</li>
            <li>{t('download_benefit_4')}</li>
            <li>{t('download_benefit_5')}</li>
          </ul>
        </div>
        
        <div className="form-section">
          <h3>{t('download_form_title')}</h3>
          <div onFocus={() => trackFormInteraction('Download Form', 'Focus')}>
            <BiginForm />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default DownloadPage;
